import {
  selectActiveUsersPagination,
  selectDeactivatedUsersPagination,
  setActiveUsersPagination,
  setDeactivatedUsersPagination,
  setUsersFinding,
  useAppDispatch,
  useAppSelector
} from '@/store';
import { InputSearchHandle } from '@repo/atomic-components';
import { KeyboardEvent as SyntheticKeyboardEvent, useCallback, useRef } from 'react';

export const useUsersSearch = () => {
  const dispatch = useAppDispatch();

  const searchInputRef = useRef<InputSearchHandle>(null);

  const activeUsersPagination = useAppSelector(selectActiveUsersPagination);
  const deactivatedUsersPagination = useAppSelector(selectDeactivatedUsersPagination);

  const handleSearchInputKeyDown = (event: SyntheticKeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && searchInputRef.current) {
      dispatch(setUsersFinding(searchInputRef.current.value));
      dispatch(setActiveUsersPagination({ ...activeUsersPagination, pageIndex: 0 }));
      dispatch(
        setDeactivatedUsersPagination({
          ...deactivatedUsersPagination,
          pageIndex: 0
        })
      );
    }
  };

  const handleResetClick = useCallback(() => {
    dispatch(setUsersFinding(''));
    dispatch(setActiveUsersPagination({ ...activeUsersPagination, pageIndex: 0 }));
    dispatch(
      setDeactivatedUsersPagination({
        ...deactivatedUsersPagination,
        pageIndex: 0
      })
    );
  }, [activeUsersPagination, deactivatedUsersPagination, dispatch]);

  return {
    searchInputRef,
    handleResetClick,
    handleSearchInputKeyDown
  };
};
